class ClassLynxUtils {
  // La fonction de filtrage personnalisée
  skillFilterFunction (itemText, queryText, item) {
    const textLowerCase = item.raw.label.toLowerCase()
    const queryTextLowerCase = queryText.toLowerCase()
    const tocheck = textLowerCase.split(/[- _/.]/)
    const reftext = queryTextLowerCase.split(/[- _/.]/)
    // Vérifie que chaque élément de ref_text est présent dans to_check
    return reftext.every(refWord =>
      tocheck.some(segment => segment.startsWith(refWord))
    )
  }

  // Fonction haute ordre pour gérer les erreurs des fonctions asynchrones
  DebounceWithTryCatch (defval, asyncFunc) {
    return async function (...args) {
      try {
        return await asyncFunc(...args)
      } catch (error) {
        return defval
      }
    }
  }

  CreateIdListFromObjects (obj) {
    return this.CreateIdListFromObjectsWithProp(obj, 'id')
  }

  CreateIdListFromObjectsWithProp (obj, propName) {
    if (obj == null) {
      return null
    }
    return obj.map(function (item) {
      return item[propName]
    }).join(', ')
  }

  CreateIdListFromList (obj) {
    if (obj == null) {
      return null
    }
    return obj.map(function (item) {
      return item
    }).join(', ')
  }

  ParseDate (dateStr) {
    const [day, month, year] = dateStr.split('/')
    return new Date(year, month - 1, day) // Les mois en JS sont de 0 à 11
  }
}

export const LynxUtils = new ClassLynxUtils()
